<div (click)="this.chipClicked.emit()" class="content">
  <ion-icon class="icon" *ngIf="icon" [name]="icon"></ion-icon>
  <div class="text"><ng-content></ng-content></div>
</div>
<div class="dismiss-button" tappable (click)="this.dismissClicked.emit()" *ngIf="showDismiss">
  <ion-icon name="alberta-cancel"></ion-icon>
</div>
